import {
  Onboarding,
  OnboardingDetails,
  OnboardingExtDataConfig,
  OnboardingGeoConfig,
  OnboardingStatus,
  OnboardingType,
  UserOnboardingStatus,
} from '../types';
import {
  OnboardingDetailsOnBackend,
  OnboardingGeoConfigOnBackend,
  OnboardingOnBackend,
  UserOnboardingStatusOnBackend,
} from './backendTypes';

export const mapOnboardingFromBackend = ({
  type,
  config,
  geo_configs_count,
}: OnboardingOnBackend): Onboarding => ({
  type: type as OnboardingType,
  config,
  geoConfigsCount: geo_configs_count,
});

export const mapOnboardingGeoConfigFromBackend = ({
  id,
  country_code,
  config,
}: OnboardingGeoConfigOnBackend): OnboardingGeoConfig => ({
  id,
  countryCode: country_code,
  config,
});

export const mapUserOnboardingStatusFromBackend = ({
  type,
  config,
  status,
}: UserOnboardingStatusOnBackend): UserOnboardingStatus => ({
  type: type as OnboardingType,
  config,
  status: status as OnboardingStatus,
});

export const mapOnboardingDetailsFromBackend = ({
  type,
  config,
  geo_configs,
  ext_data_configs,
}: OnboardingDetailsOnBackend): OnboardingDetails => ({
  type: type as OnboardingType,
  config,
  geoConfigs: (geo_configs ?? []).map(item =>
    mapOnboardingGeoConfigFromBackend(item),
  ),
  extDataConfigs: (ext_data_configs ?? []).map(
    (item): OnboardingExtDataConfig => ({
      id: item.id,
      extName: item.ext_name,
      extValue: item.ext_value,
      config: item.config,
      priority: item.priority,
    }),
  ),
});
